import React from "react";
import MobileBottomNav from "./MobileBottomNav";
import "./mobile.css";

export default function MobileLayout({ title, rightActions, children }) {
  return (
    <div className="mobile-shell">
      <div className="mobile-topbar">
        <div className="mobile-topbar__title">{title}</div>
        <div className="mobile-topbar__actions">{rightActions}</div>
      </div>

      <div className="mobile-content">{children}</div>

      <MobileBottomNav />
    </div>
  );
}


